import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const getCalendar = (year, month) => {
  return Request({
    method: 'get',
    url: `${baseUrl}/calendar/${year}/${month}`,
    needToken: true
  });
};

